import Checkbox from 'lib/components/checkbox/checkbox'
import { ArrowRight } from 'lucide-react'
import { useState } from 'react'
import { useBillingPlans } from './billing-plans-context'
import { displayPlanPrice, getTotal } from 'lib/util/billing'

export default function BillingModalReview() {
  const [checked, setChecked] = useState(false)
  const { currentPlans, selectedPlans } = useBillingPlans()

  return (
    <div className="tw-flex tw-flex-col tw-gap-4 tw-text-peppercorn-900">
      <div className="tw-flex tw-items-center tw-justify-center tw-gap-4">
        <div className="tw-flex tw-w-1/2 tw-flex-col tw-items-start tw-justify-center tw-gap-2">
          <div className="tw-text-sm tw-font-semibold tw-text-peppercorn">Current</div>
          <div className="tw-h-36 tw-w-full tw-rounded tw-border tw-border-solid tw-border-peppercorn-200 tw-p-4">
            <div className="tw-flex tw-h-5 tw-items-center tw-justify-between tw-self-stretch">
              {currentPlans.platformPlan && (
                <>
                  <div>{currentPlans.platformPlan.name}</div>
                  <div>{displayPlanPrice(currentPlans.platformPlan)}</div>
                </>
              )}
            </div>
            <div className="tw-flex tw-h-5 tw-items-center tw-justify-between tw-self-stretch">
              {currentPlans.creativePlan && (
                <>
                  <div>
                    {currentPlans.creativePlan.name} - {currentPlans.creativePlan.dailyTime / 60}hrs
                  </div>
                  <div>{displayPlanPrice(currentPlans.creativePlan)}</div>
                </>
              )}
            </div>
            <div className="tw-flex tw-h-5 tw-items-center tw-justify-between tw-self-stretch">
              {currentPlans.professionalPlan && (
                <>
                  <div>{currentPlans.professionalPlan.name}</div>
                  <div>{displayPlanPrice(currentPlans.professionalPlan)}</div>
                </>
              )}
            </div>
            <div className="tw-mt-2 tw-flex tw-h-5 tw-items-center tw-justify-between tw-self-stretch tw-font-semibold">
              <div>Total</div>
              <div>{getTotal(Object.values(currentPlans))}</div>
            </div>
            <div>7.25% sales tax applied</div>
          </div>
        </div>
        <div className="tw-flex tw-items-center tw-justify-center tw-gap-4">
          <ArrowRight />
        </div>
        <div className="tw-flex tw-w-1/2 tw-flex-col tw-items-start tw-justify-center tw-gap-2">
          <div className="tw-text-sm tw-font-semibold tw-text-peppercorn">New</div>
          <div className="tw-h-36 tw-w-full tw-rounded tw-border tw-border-solid tw-border-peppercorn-200 tw-p-4">
            <div className="tw-flex tw-h-5 tw-items-center tw-justify-between tw-self-stretch">
              {selectedPlans.platformPlan && (
                <>
                  <div>{selectedPlans.platformPlan.name}</div>
                  <div>{displayPlanPrice(selectedPlans.platformPlan)}</div>
                </>
              )}
            </div>
            <div className="tw-flex tw-h-5 tw-items-center tw-justify-between tw-self-stretch">
              {selectedPlans.creativePlan && (
                <>
                  <div>
                    {selectedPlans.creativePlan.name} - {selectedPlans.creativePlan.dailyTime / 60}hrs
                  </div>
                  <div>{displayPlanPrice(selectedPlans.creativePlan)}</div>
                </>
              )}
            </div>
            <div className="tw-flex tw-h-5 tw-items-center tw-justify-between tw-self-stretch">
              {selectedPlans.professionalPlan && (
                <>
                  <div>{selectedPlans.professionalPlan.name}</div>
                  <div>{displayPlanPrice(selectedPlans.professionalPlan)}</div>
                </>
              )}
            </div>
            <div className="tw-mt-2 tw-flex tw-h-5 tw-items-center tw-justify-between tw-self-stretch tw-font-semibold">
              <div>Total</div>
              <div>{getTotal(Object.values(selectedPlans))}</div>
            </div>
            <div>7.25% sales tax applied</div>
          </div>
        </div>
      </div>
      <div className="tw-border-1/2 tw-border-b tw-border-solid tw-border-peppercorn-200" />
      <div className="tw-flex tw-flex-col tw-items-start tw-gap-2 tw-self-stretch tw-rounded tw-border tw-border-peppercorn-900 tw-bg-peppercorn-900 tw-p-4 tw-text-white">
        <div className="tw-flex tw-h-5 tw-items-center tw-justify-between tw-self-stretch">
          <div>Today’s prorated subtotal</div>
          <div>$20.32</div>
        </div>
        <div className="tw-flex tw-h-5 tw-items-center tw-justify-between tw-self-stretch">
          <div>Sales tax (7.25% California)</div>
          <div>$1.71</div>
        </div>
        <div className="tw-mt-2 tw-flex tw-h-5 tw-items-center tw-justify-between tw-self-stretch tw-font-semibold">
          <div>Today’s Prorated Total</div>
          <div>$22.03</div>
        </div>
        <div>Your new plans will be billed starting next cycle on April 4, 2025</div>
      </div>
      <div className="tw-flex tw-items-start tw-gap-2 tw-self-stretch">
        <div className="tw-pt-1">
          <Checkbox isChecked={checked} onClick={() => setChecked(!checked)} />
        </div>
        <div>
          By clicking this box, you are authorizing us to immediately charge your payment method for the full amount for
          any subscription plan changes. Any cancellations will take place at the end of their billing period, and all
          new subscriptions / upgrades are non-refundable and are immediately paid in full. If you have any questions
          about this, please contact us.
        </div>
      </div>
    </div>
  )
}
